/**
 * A stable per-device id, persisted in localStorage. Mirrors spot-client's random
 * device id: it is the ONLY identifier we log (never PII), and it is the endpoint
 * id the room-do roster + pairing identity are keyed on. Distinct keys per role so
 * a TV and a Remote opened in the same browser don't collide.
 */

import { log } from './log.js';

function makeId(prefix: string): string {
    return `${prefix}-${crypto.randomUUID()}`;
}

/** Get (or lazily create) the stable device id for a role. */
export function getDeviceId(role: 'tv' | 'remote'): string {
    const key = `spaces.deviceId.${role}`;

    try {
        const existing = localStorage.getItem(key);

        if (existing) {
            return existing;
        }

        const created = makeId(role);

        localStorage.setItem(key, created);

        return created;
    } catch {
        // localStorage unavailable (private mode / sandbox) — fall back to ephemeral.
        log.warn('localStorage unavailable; using ephemeral device id');

        return makeId(role);
    }
}
